import { drivelabels_v2 } from '@googleapis/drivelabels';
import { getLabelLifecycleStatus } from './label-lifecycle';

type Label = drivelabels_v2.Schema$GoogleAppsDriveLabelsV2Label;

export function isLabelDisableable(label: Label) {
  const status = getLabelLifecycleStatus(label);
  return status === 'PUBLISHED' || status === 'PUBLISHED_NEW_DRAFT';
}

export function hasUndisableableLabel(labels: Label[]) {
  return labels.some((label) => !isLabelDisableable(label));
}
